export default __webpack_public_path__ + "static/media/status-declined.987446d1.svg";